/* eslint-disable indent */
// Utils
import { POST } from '../../../utils/fetchWrappers';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// API URLs
import {
    API_FETCH_BULK_UPLOAD_RECENT,
    API_BULK_UPLOAD_FILE,
    API_FETCH_BULK_UPLOAD_PREFILLED_FILE,
    API_BULK_UPLOAD_FILE_TRANSACTION_VIEW,
    API_BULK_UPLOAD_DOWNLOAD_FILE,
} from '../../../utils/API/apiUrls';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import { downloadFile } from '../../../utils/helperMethods';
import * as bulkRefundActions from './bulkRefund.actions';

// Constants
import {
    FETCH_BULK_REFUND_BY_ID_REQUEST,
    FETCH_BULK_REFUND_REQUEST,
    UPLOAD_BULK_REFUND_FILE_REQUEST,
    DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST,
    DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST,
} from './bulkRefund.constants';

// Library
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';
import moment from 'moment';

export function* fetchBulkUploadRecentDetails(actions) {
    yield put(bulkRefundActions.showLoader());
    try {
        const request = {
            fileProcessEnum: 'BULK_REFUND_FILE_UPLOAD',
        };
        const { data } = yield call(
            POST,
            API_FETCH_BULK_UPLOAD_RECENT,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(bulkRefundActions.fetchBulkRefundDataSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                bulkRefundActions.fetchBulkRefundDataError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        // const { data } = response;
        // yield put(bulkRefundActions.fetchBulkRefundDataError({ error: data }));
    }
    yield put(bulkRefundActions.hideLoader());
}

export function* uploadBulkUploadFileRequest(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const { data } = yield call(
            POST,
            API_BULK_UPLOAD_FILE,
            payload,
            {
                'Content-Type': 'multipart/form-data;',
            },
            true
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(bulkRefundActions.uploadBulkUploadFileSuccess(data));
            toast.info('File upload successful');
        } else if (data && data.errorMessage) {
            yield put(
                bulkRefundActions.uploadBulkUploadFileError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(bulkRefundActions.uploadBulkUploadFileError({ error: data }));
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchBulkRefundFileTableDataByIdDetails(actions) {
    yield put(bulkRefundActions.showLoader());
    try {
        const request = {
            fileProcessEnum: 'BULK_REFUND_FILE_UPLOAD',
            ...actions.payload,
        };
        const { data } = yield call(
            POST,
            API_BULK_UPLOAD_FILE_TRANSACTION_VIEW,
            request
        );
        if (data && data.refundReqResLst) {
            yield put(
                bulkRefundActions.fetchBulkRefundFileTableDataByIdSuccess({
                    response: data,
                    request,
                })
            );
        } else if (data && data.errorMessage) {
            yield put(
                bulkRefundActions.fetchBulkRefundFileTableDataByIdError({
                    error: data.errorMessage,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            bulkRefundActions.fetchBulkRefundFileTableDataByIdError({
                error: data,
            })
        );
    }
    yield put(bulkRefundActions.hideLoader());
}

export function* downloadBulkRefundFileByIdDetails(actions) {
    yield put(loaderActions.showLoader());
    try {
        const request = {
            ...actions.payload,
        };

        const { data } = yield call(
            POST,
            API_BULK_UPLOAD_DOWNLOAD_FILE,
            request
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            downloadFile(data.fileUrl);
        } else if (data && data.errorMessage) {
            yield put(
                bulkRefundActions.downloadBulkRefundFileByIdSuccess({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            bulkRefundActions.downloadBulkRefundFileByIdError({ error: data })
        );
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

export function* downloadBulkRefundPreFilledFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const requestPayload = { ...payload };
        requestPayload.startDateTime = requestPayload.createdOn.startDate
            ? moment(requestPayload.createdOn.startDate)
                  .startOf('day')
                  .format('YYYY-MM-DD HH:mm:ss')
            : '';
        requestPayload.endDateTime = requestPayload.createdOn.endDate
            ? moment(requestPayload.createdOn.endDate)
                  .endOf('day')
                  .format('YYYY-MM-DD HH:mm:ss')
            : '';

        delete requestPayload.createdOn;

        const { data } = yield call(
            POST,
            API_FETCH_BULK_UPLOAD_PREFILLED_FILE,
            requestPayload
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            downloadFile(data.fileUrl);
        } else if (data && data.errorMessage) {
            yield put(
                bulkRefundActions.downloadBulkRefundPreFilledFileError({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            bulkRefundActions.downloadBulkRefundFileByIdError({ error: data })
        );
        if (data.errorMessage) {
            toast.info(data.errorMessage);
        }
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* bulkRefundSaga(actions) {
    yield takeLatest(FETCH_BULK_REFUND_REQUEST, fetchBulkUploadRecentDetails);
    yield takeLatest(
        UPLOAD_BULK_REFUND_FILE_REQUEST,
        uploadBulkUploadFileRequest
    );
    yield takeLatest(
        FETCH_BULK_REFUND_BY_ID_REQUEST,
        fetchBulkRefundFileTableDataByIdDetails
    );
    yield takeLatest(
        DOWNLOAD_BULK_REFUND_FILE_BY_ID_REQUEST,
        downloadBulkRefundFileByIdDetails
    );

    yield takeLatest(
        DOWNLOAD_BULK_REFUND_PRE_FILLED_FILE_REQUEST,
        downloadBulkRefundPreFilledFile
    );
}
